import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    meta: {},
    accountInfo: {},
  },
  mutations: {
    setMeta(state, meta) {
      state.meta = meta;
    },
    setAccountInfo(state, accountInfo) {
      state.accountInfo = accountInfo;
    },
  },
  actions: {

  },
});
